import { useState } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Btn, H5, P } from '../../../../AbstractElements';
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader';
import { staticModalData } from '../../../../Data/Ui-Kits/Modal/Modal';
import { MofiLogin, StaticBackdropModalBtn, StaticBackdropModals } from '../../../../utils/Constant';
import CommonModal from '../Common/CommonModal';
import StaticForm from './StaticForm';

const StaticBackdropModal = () => {
  const [staticModal, setStaticModal] = useState(false);
  const staticModalToggle = () => setStaticModal(!staticModal);
  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={StaticBackdropModals} span={staticModalData} />
        <CardBody>
          <Btn color="primary" onClick={staticModalToggle}>{StaticBackdropModalBtn}</Btn>
          <CommonModal backdrop="static"  modalBodyClassName="social-profile text-start" isOpen={staticModal} toggle={staticModalToggle}>
            <div className="modal-toggle-wrapper">
              <H5>{MofiLogin}</H5>
              <P>Fill in your information below to continue.</P>
              <StaticForm staticModalToggle={staticModalToggle} />
            </div>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  )
}

export default StaticBackdropModal